"use strict";

import GError from "./GError"

export type TCronCallback = (next:Function) => void

interface IJob {
    lastRun:number|Date
    elapsed:number
    job:Function
    interval:number
    id:number
}
export default class Cron {
    _crons : Record<string,IJob> = {}

    static _i:Cron
    static get i(){
        if (!Cron._i) Cron._i = new Cron()
        return Cron._i
    }

    /**
     * 
     * @param {string} Cron job name 
     * @param {Function} callback (next) => {}
     * @param {number} interval Interval in msec
     */
    start(name:string, callback:TCronCallback, interval:number) {
        if (name in this._crons) {
            console.log("Cron " + name + " already started");
            throw new GError(GError.Status.ServerError, "Cron " + name + " already started");
        }
        
        const job = this._job(name, callback);
        this._crons[name] = {
            lastRun:0,elapsed:0,
            job,interval,id:setInterval(job, interval)
        }
    };

    _job(name:string, callback:TCronCallback) : Function {
        return () => {
            const started = Date.now()
            callback(() => {
                const job = this._crons[name]
                if (!job) return

                const now = new Date();
                job.lastRun = now
                job.elapsed = now.getTime() - started
            });
        };
    }

    stop(name:string) {
        const job = this._crons[name]
        if (!job) return

        clearInterval(job.id)
        delete this._crons[name]
    }

    stopAll(){
        for(const job of Object.values(this._crons)) clearInterval(job.id)
        this._crons = {}
    }
}
